import axios from "axios";
import { FETCH_ALL_DISCOUNT_API } from "../Constants/Apis";

export const getDiscounts = async () => {
  try {
    return axios.get(FETCH_ALL_DISCOUNT_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createDiscount = async (payload) => {
  try {
    return axios.post(FETCH_ALL_DISCOUNT_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateDiscount = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_DISCOUNT_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteDiscount = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_DISCOUNT_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

